.task-detail-content {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.task-detail-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.task-detail-overview {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
}

.task-detail-overview-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

.task-detail-properties {
    flex: none;
    padding: 0 1.5rem;
}

.task-detail-property-row {
    box-sizing: border-box;
    gap: 1rem;
    min-height: 2.75rem;
    padding: 0.5rem 0;
    width: 100%;
}

.task-detail-property-label {
    flex: none;
    white-space: nowrap;
}

.task-detail-property-value {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
}

.task-detail-editor {
    flex: none;
    padding: 1.5rem;
}

.task-detail-footer {
    box-sizing: border-box;
    flex: none;
    margin-top: auto;
    padding: 0.75rem 1.5rem;
    width: 100%;
}

.task-detail-tabs > .ant-tabs-nav {
    flex: none;
    margin-bottom: 0;
    padding: 0 1rem;
}

.task-detail-tabs-document > .ant-tabs-nav {
    display: none;
}

.task-detail-tabs > .ant-tabs-content-holder {
    flex: 1;
    min-height: 0;
}

.task-detail-tabs > .ant-tabs-content-holder > .ant-tabs-content,
.task-detail-tabs > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
    height: 100%;
    min-height: 0;
}

.task-detail-panel {
    box-sizing: border-box;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    padding: 0.75rem;
}
